const sanityClient = require("@sanity/client");

module.exports = sanityClient({
  projectId: "euv0xe6k",
  dataset: "production",
  apiVersion: "2022-08-02",
  useCdn: false,
});
